import React, { Component, Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { displayDateFormat, imgStoragePath } from '../../../../constants';
import { InvoiceConfigCol } from '../../Elements';
import { ordinalSuffixOf, getLocalStorageInfo } from '../../../../utils';
import { checkPermission } from '../../../../utils_v2';
import editIconWhite from '../../../../shared/assets/img/edit_icon_white.svg';
import { titanInstance,gaTelesisInstance, avationPlcInstance, mtInstance, leshaBankInstance,hanwahaInstance } from '../../../../shared_elements/components';
import { jetStreamInstance } from '../../../../lease_management/Leases';
export default class LeaseRentalInvoice extends Component{
  constructor(props){
    super(props);
  }

  render(){
    const { rentalInvoiceView, contractInfo, activeTab } = this.props;
    return(
      <div className="contract-invoice-config data-invoice-block">
        { checkPermission('contracts', 'lease_rental_rate', 'U') && contractInfo?.hdlineInfo?.archived_asset ==false ?
          <span style={{float:'right',marginRight:'23px'}}>
            <img onClick={this.props.toggleEditSideBar} style={{zIndex:'5'}} src={editIconWhite} alt="edit" className="edit-card-icon" width="16"/>
          </span>:null
        }
        {activeTab === '1' ?<>
        <Row>
          <InvoiceConfigCol
            size="3"
            title="Auto Invoice Generation Day"
            value={rentalInvoiceView.rental_invoice_day_of_month ? ordinalSuffixOf(rentalInvoiceView.rental_invoice_day_of_month) + ' of Month' : '--' }
          />
          <InvoiceConfigCol
            size="3"
            title="Invoice Due Days"
            value={rentalInvoiceView.rental_invoice_due_day_of_month ? ordinalSuffixOf(rentalInvoiceView.rental_invoice_due_day_of_month) + ' of Month': '--' }
          />
          <InvoiceConfigCol
            size="3"
            title="Default Bank"
            value={rentalInvoiceView?.rental_default_bank?.name ? rentalInvoiceView?.rental_default_bank?.name: '--' }
          />
          <InvoiceConfigCol
            size="3"
            title="Invoice Due Month"
            value={rentalInvoiceView.rental_invoice_is_due_day_next_month ? 'Next Month':'Same Month'}
          />

        </Row>
        <Row>
          {jetStreamInstance ?
            <InvoiceConfigCol
              size="3"
              title="Invoice Due Day falls at last day of the Billing Month"
              value={rentalInvoiceView.rental_invoice_is_due_day_last_day_month === true ? 'YES' : rentalInvoiceView.rental_invoice_is_due_day_last_day_month === false ? 'NO' : '--'}
            /> : null
          }
          <InvoiceConfigCol
            size="3"
            title="Rental Billing Cycle"
            value={rentalInvoiceView.lease_rental_period ? rentalInvoiceView?.lease_rental_period === 1 ? 'Monthly' : 'As Per Lease Period' : '--'}
          />
          {rentalInvoiceView?.lease_rental_period===2 ?
          <InvoiceConfigCol
            size="3"
            title="Invoice Day"
            value={rentalInvoiceView.lease_based_invoice_start_day ? ordinalSuffixOf(rentalInvoiceView.lease_based_invoice_start_day) + ' of Month':'--'}
          />:null}
        <InvoiceConfigCol
            size="3"
            title="Description"
            value={rentalInvoiceView.rental_description ? rentalInvoiceView.rental_description:'--'}
          />
            {hanwahaInstance ?
              <InvoiceConfigCol
                size="3"
                title="Account Code"
                value={rentalInvoiceView.rental_account_code || '--'}
              /> : null
            }
          {(titanInstance || gaTelesisInstance) ? <InvoiceConfigCol
            size="3"
            title="Reference Number"
            value={rentalInvoiceView.reference_number_rental ? rentalInvoiceView.reference_number_rental : '--'}
          /> :null}
          {(gaTelesisInstance) ? <>
            <InvoiceConfigCol
              size="3"
              title="QIS Number"
              value={rentalInvoiceView?.rental_account_titan_extra_fields?.rental_qis_number ? rentalInvoiceView?.rental_account_titan_extra_fields.rental_qis_number : '--'}
            />
            <InvoiceConfigCol
              size="3"
              title="Sales Order Number"
              value={rentalInvoiceView?.rental_account_titan_extra_fields?.rental_sales_order_number ? rentalInvoiceView?.rental_account_titan_extra_fields?.rental_sales_order_number : '--'}
            /> </> : null}
          {(titanInstance||avationPlcInstance||mtInstance||leshaBankInstance) ?<> <InvoiceConfigCol
              size="3"
              title="Remarks"
              value={rentalInvoiceView.remarks_rental ? rentalInvoiceView.remarks_rental : '--'}
            />
            <InvoiceConfigCol
              size="3"
              title="Remarks Date"
              value={rentalInvoiceView?.rental_account_titan_extra_fields?.remarks_date ? moment(rentalInvoiceView?.rental_account_titan_extra_fields?.remarks_date).format(displayDateFormat) : '--'}
            /></>
            : null}  
        </Row>
        <p style={{display:'none'}}>Invoice Sender</p>
        <Row style={{display:'none'}}>
        <InvoiceConfigCol
            size="4"
            title="Invoice From"
            value={rentalInvoiceView.rental_from_company_name ? rentalInvoiceView.rental_from_company_name: '--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Company Address"
            value={rentalInvoiceView.rental_from_company_address ? rentalInvoiceView.rental_from_company_address: '--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Contact Details"
            value={rentalInvoiceView.rental_from_company_contact ? rentalInvoiceView.rental_from_company_contact: '--' }
          />
        </Row>
        <p style={{display:'none'}}>Invoice Receiver</p>
        <Row style={{display:'none'}}>
          <InvoiceConfigCol
            size="4"
            title="Invoice To"
            value={rentalInvoiceView.rental_to_company_name ? rentalInvoiceView.rental_to_company_name: '--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Company Address"
            value={rentalInvoiceView.rental_to_company_address ? rentalInvoiceView.rental_to_company_address: '--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Contact Details"
            value={rentalInvoiceView.rental_to_company_contact ? rentalInvoiceView.rental_to_company_contact: '--' }
          />
        </Row>
        <Row className="invoice-last-block" style={{display:'none'}}>
          <InvoiceConfigCol
            size="4"
            title="Bank Name"
            value={ rentalInvoiceView.rental_bank_name ? rentalInvoiceView.rental_bank_name:'--' }
          />

          <InvoiceConfigCol
            size="4"
            title="Bank Account Name"
            value={ rentalInvoiceView.rental_bank_account_name ? rentalInvoiceView.rental_bank_account_name:'--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Bank Account Number"
            value={ rentalInvoiceView.rental_bank_account_number ? rentalInvoiceView.rental_bank_account_number:'--' }
          />

          <InvoiceConfigCol
            size="4"
            title={getLocalStorageInfo().defaultLessor.id==14?"Bank ABA":"Bank IBAN"}
            value={ rentalInvoiceView.rental_bank_iban ? rentalInvoiceView.rental_bank_iban:'--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Bank Swift Code"
            value={ rentalInvoiceView.rental_bank_swift_code ? rentalInvoiceView.rental_bank_swift_code:'--' }
          />
          <InvoiceConfigCol
            size="4"
            title="Bank SORT Code"
            value={ rentalInvoiceView.rental_bank_sort_code ? rentalInvoiceView.rental_bank_sort_code:'--' }
          />
        {
          [14, 242].includes(getLocalStorageInfo().defaultLessor.id) ?
          <Fragment>
            <InvoiceConfigCol
              size="4"
              title="Hub Account"
              value={rentalInvoiceView.hub_number ? rentalInvoiceView.hub_number :'--'}
            />
            <InvoiceConfigCol
              size="4"
              title="VAT Number"
              value={rentalInvoiceView.vat_number ? rentalInvoiceView.vat_number : '--'}
            />
        </Fragment> :null
        }
          <InvoiceConfigCol
            size="4"
            title="Footer Note"
            value={ rentalInvoiceView.rental_footer_note ? rentalInvoiceView.rental_footer_note:'--' }
          />
        </Row></>:
          <Row>
            <InvoiceConfigCol
              size="4"
              title="Management Fee %"
              value={rentalInvoiceView.management_tax ? rentalInvoiceView.management_tax : '--'}
            />
            <InvoiceConfigCol
              size="4"
              title="VAT %"
              value={rentalInvoiceView.vat_tax ? rentalInvoiceView.vat_tax : '--'}
            />
            <InvoiceConfigCol
              size="4"
              title="Management Fee Bank"
              value={rentalInvoiceView?.management_bank_id?.name ? rentalInvoiceView?.management_bank_id?.name : '--'}
            />
          </Row> 
        }
     </div>
    )
  }
}
